import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_TITLE_FOR_USER_MUTATION = gql`
  mutation updateOfferTitle($targetUserId: String!, $docVersion: DocumentVersionInput!, $targetBranchId: String) {
    updateOfferTitle(targetUserId: $targetUserId, documentVersion: $docVersion, targetBranchId: $targetBranchId) {
      title
      dealerTitle
      manufacturerTitle
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferTitleForUserMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_TITLE_FOR_USER_MUTATION;
}
